export default "__VITE_ASSET__BRWBn6nB__"